import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Estado vazio — componente 10. Três partes obrigatórias:
 * o que é aquela lista (`title`), por que ela importa (`description`) e a ação que a preenche (`action`).
 * Sem ilustração, sem ícone gigante.
 */
export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  description: ReactNode
  action?: ReactNode
  /** Com fio em volta — para quando o vazio ocupa o lugar de uma tabela. */
  bordered?: boolean
}

export function EmptyState({
  title,
  description,
  action,
  bordered = true,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center px-6 py-11 text-center',
        bordered && 'border-hairline bg-surface border',
        className,
      )}
      {...props}
    >
      <h3 className="font-display text-name text-ink leading-[1.3] font-normal">{title}</h3>
      <p className="font-body text-body text-secondary mt-2 max-w-[420px] font-light">
        {description}
      </p>
      {action ? (
        <div className="mt-[14px] flex flex-wrap justify-center gap-[10px]">{action}</div>
      ) : null}
    </div>
  )
}
